import _ from 'lodash'
import {
    requiredIf,
    decimal,
    maxValue,
    required,
    minValue,
    integer,
    minLength,
    maxLength,
} from 'vuelidate/lib/validators'

const sumOfVariablesWeightMustBeEqualOneHundred = (_, vm) => {
    const total = vm.variables.reduce((acumulador, variable) => {
        return acumulador + parseFloat(variable.result_weight)
    }, 0)
    return total == 100
}

const sumOfTargetLevelsWeightMustBeEqualOneHundred = (_, vm) => {
    if (vm.module == 'target') {
        const total = ['personal_weight', 'team_weight', 'unit_weight'].reduce(
            (acc, key) => {
                if (vm[key]) {
                    return acc + parseFloat(vm[key])
                }
                return acc
            },
            0
        )
        return total == 100
    }
    return true
}

const quadrantsLimits = items => {
    const hasDuplicatedValues =
        _.filter(items, (val, i, iteratee) => _.includes(iteratee, val, i + 1))
            .length > 0
    if (hasDuplicatedValues) {
        return false
    }

    return items.every((value, index) => {
        const hasNextValue = index < items.length - 1
        const hasPreviousValue = index > 0
        const isLessThanNext = hasNextValue ? value < items[index + 1] : true
        const isBiggerThanPrevious = hasPreviousValue
            ? value > items[index - 1]
            : true

        return isLessThanNext && isBiggerThanPrevious
    })
}

const targetMaxValue = axis => {
    return (value, vm) => {
        const prop = `${axis}_max`
        const max = _.max(vm.quadrants.map(v => v[prop]))
        return value <= max
    }
}

const targetMinValue = axis => {
    return (value, vm) => {
        const prop = `${axis}_min`
        const min = _.min(vm.quadrants.map(v => v[prop]))
        return value >= min
    }
}

const variables = {
    required,
    sumOfVariablesWeightMustBeEqualOneHundred,
    $each: {
        id: {},
        axis: {
            required,
        },
        category_id: {
            required: requiredIf(vm => vm.module == 'values'),
        },
        module: {
            required,
        },
        result_type: {
            required,
        },
        result_weight: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(100),
        },
        personal_weight: {
            minValue: minValue(0),
            maxValue: maxValue(100),
            sumOfTargetLevelsWeightMustBeEqualOneHundred,
            required: requiredIf(vm => vm.module == 'target'),
        },
        team_weight: {
            minValue: minValue(0),
            maxValue: maxValue(100),
            sumOfTargetLevelsWeightMustBeEqualOneHundred,
            required: requiredIf(vm => vm.module == 'target'),
        },
        unit_weight: {
            minValue: minValue(0),
            maxValue: maxValue(100),
            sumOfTargetLevelsWeightMustBeEqualOneHundred,
            required: requiredIf(vm => vm.module == 'target'),
        },
    },
}

const axis = {
    title: {
        required,
        maxLength: maxLength(80),
    },
    variables: { ...variables },
}

export default {
    admission_date: {},
    title: {
        required,
    },
    calibration_type: {
        required,
    },
    rows: {
        required,
        integer,
        minValue: minValue(1),
        maxValue: maxValue(6),
    },
    columns: {
        required,
        integer,
        minValue: minValue(1),
        maxValue: maxValue(6),
    },
    x_target_value: {
        decimal,
        required,
        minValue: targetMinValue('x'),
        maxValue: targetMaxValue('x'),
    },
    y_target_value: {
        decimal,
        required,
        minValue: targetMinValue('y'),
        maxValue: targetMaxValue('y'),
    },
    status: {
        required,
    },
    teams: {
        minLength: requiredIf(
            ({ occupation_groups }) => occupation_groups.length == 0
        ),
    },
    occupation_groups: {
        minLength: requiredIf(({ teams }) => teams.length == 0),
    },
    periods: {
        required,
    },
    limits: {
        x: {
            quadrantsLimits,
            minLength: minLength(2),
            $each: {
                decimal,
                minValue: minValue(0),
            },
        },
        y: {
            quadrantsLimits,
            minLength: minLength(2),
            $each: {
                decimal,
                minValue: minValue(0),
            },
        },
    },
    axis_x: { ...axis },
    axis_y: { ...axis },
    quadrants: {
        required,
        $each: {
            id: {},
            title: { required },
            description: {},
            x_min: {},
            x_max: {},
            y_min: {},
            y_max: {},
        },
    },
}
